import React, { useCallback, useMemo, useRef, useState } from 'react';

import { message } from 'antd';
import cn from 'classnames'
import flatten from 'lodash/flatten'
import { inject, observer } from 'mobx-react'
import Image from 'next/legacy/image'
import Router from 'next/router';

import { Button, Popover } from '@components/Element'
import Icon from '@components/Icon';
import ResourceUpload from '@components/ResourceUpload'
import RichEditor from '@components/RichEditor';
import TopicTag from '@components/TopicTag'
import defaultAvatar from '@images/avata.webp';
import { useAuthSession, useIsomorphicLayoutEffect } from '@lib/hooks';
import pubsub from '@lib/scripts/pubsub'
import { getLoginPath, I18n } from '@utils/index';

import { useEditorSubmit, useLimit, useOss } from '../hooks'
import HotTopic from '../HotTopic'

import styles from './index.module.css'
// import { getListData } from '@widget/market/TradeList/utils';

const T = ({
  userStore: { userInfo: { id }, socialUserInfo: { avatar } }
}) => {
  const [content, setcontent] = useState({
    editorText: '',
    editorImageArr: [],
    editorVideoArr: []
  })
  const [buffData, setbuffData] = useState([])
  const [loading, setloading] = useState(false)
  // const router = useRouter()
  const [topic, settopic] = useState({})
  const [topicvisible, settopicvisible] = useState(false)
  const OSSFetch = useOss()
  const submitFetch = useEditorSubmit(id)
  const toolbarref = useRef({})
  const sourceLimit = useLimit()
  const editorref = useRef({})
  const isLogin = useAuthSession({ redirectTo: null });
  const editorContainRef = useRef({})

  console.log(topic, 'editorref')

  useIsomorphicLayoutEffect(() => {
    pubsub.subscribe('QUICK_POST_DONE', () => {})
    return () => {
      pubsub.unSubscribe('QUICK_POST_DONE', () => {});
    }
  }, [])

  const editorChange = useCallback((data) => {
    console.log(data, 'datadatadata')
    setcontent(data)
  }, [])

  const onTopBarChange = (data) => {
    setbuffData([...buffData, ...data])
  }

  const disabled = useMemo(() => {
    const { editorImageArr, editorVideoArr, editorText } = content
    if (editorImageArr.length > 0 || editorVideoArr.length > 0) {
      return false
    }
    if (editorText.length > 8000) {
      return true
    }
    return editorText === ''
  }, [content])

  const onComplete = (res, type) => {
    if (sourceLimit(res, type, content)) {
      return
    }
    const toolBarData = type === 'image' ? res : [res[0]]
    onTopBarChange(res)
    editorref.current.onToolbarClick(type, toolBarData)
  }

  const onSubmit = async function () {
    if (!isLogin) {
      Router.push(getLoginPath());
      return
    }
    setloading(true)
    const editUploadUrl = [...content.editorImageArr, ...content.editorVideoArr].map(item => item.uri)
    // const endUploadData = buffData.filter(i => editUploadUrl.indexOf(i.value) > -1)
    const endUploadData = flatten(editUploadUrl.map(i => {
      return buffData.filter(i2 => i2.value === i)
    }))
    const sourceReturnUrl = await OSSFetch(endUploadData, id)
    submitFetch({
      publishHtml: content.publishHtml,
      sourceReturnUrl: sourceReturnUrl,
      simple: true,
      topic,
      title: '',
      callBack: () => {
        editorref.current.init()
        message.success(I18n.t('publishPostSuccess'))
        pubsub.publish('QUICK_POST_DONE');
        // Router.push('/community?activeKey=2')
        setloading(false)
        setbuffData([])
        settopic([])
        setcontent({
          editorText: '',
          editorImageArr: [],
          editorVideoArr: []
        })
        // await setreload(false)
        // await setreload(true)
        // router.back()
      },
      errorCallBack: () => setloading(false)
    })
  }

  const onScroll = (scrollHeight) => {
    // scrollTop
    console.log(scrollHeight, 'scrollHeight')
    editorContainRef.current.scroll({ top: scrollHeight, behavior: 'smooth' })
  }

  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <Image
        src={avatar || defaultAvatar}
        layout="fixed"
        width={32}
        height={32}
        className='image_borderRadius_32'
        alt=''
        />
        <div className={styles.editorContain} ref={editorContainRef}>
          <RichEditor
            className={styles.editor}
            onChange={editorChange}
            setPlaceholder={I18n.t('editor.ple')}
            editorBackground={'#F6F8FB'}
            parentRef={editorref}
            onScroll={onScroll}
            placeholderColor='#BCC1CE'
          />
        <div>
        <TopicTag
          itemData={{
            topicId: topic.id,
            topicContent: topic.content
          }}
          onDelete={() => settopic({})}
          type='editor'
        />
        </div>
        </div>
      </div>
      <div className={styles.toolbar} ref={toolbarref}>
        <div className={styles.toolbarItem} >
          <Popover
            getPopupContainer={() => toolbarref.current}
            // contenTitle='热门话题'sadsd
            trigger='click'
            // mode='modal'
            align={{
              offset: [110, -10]
            }}
            hasArrow={false}
            visible={topicvisible}
            onVisibleChange={(e) => settopicvisible(e)}
            content={<HotTopic
            onClick={(e) => {
              settopicvisible(false)
              settopic(e)
            }}
            placement='bottom'
            />}
           >
        <div style={{ display: ' flex' }}>
          <Icon name={'topic'} />
          <span className={styles.toolbarItemTitle}>{I18n.t('tags')}</span>
          </div>
          </Popover>
        </div>
        <div className={styles.toolbarItem}>
          <ResourceUpload
            uploadType='image'
            iconName={'image'}
            id='image'
            onComplete={onComplete}
          >
            <span className={styles.toolbarItemTitle}>{I18n.t('image')}</span>
          </ResourceUpload>
        </div>
        <div className={styles.toolbarItem}>
          <ResourceUpload
              uploadType='video'
              iconName={'video'}
              id='video'
              onComplete={onComplete}
              iconClass={styles.videoIcon}
            >
            <span className={styles.toolbarItemTitle}>{I18n.t('video')}</span>
          </ResourceUpload>
        </div>
        <div className={cn('DINPro', styles.limit, {
          [styles.red]: content.editorText.length >= 8000,
          [styles.hidden]: content.editorText === ''
        })}>
          {`${content.editorText.length || 0}/8000`}
        </div>
        <Button
          type='primary'
          className={styles.button}
          onClick={onSubmit}
          disabled={disabled}
          loading={loading}
        >{I18n.t('community_published')}
        </Button>
      </div>
    </div>
  )
}

export default inject(rootStore => ({
  userStore: rootStore.store.userStore
}))(observer(T))
